import { Component, OnInit } from '@angular/core';
//import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { NavController } from '@ionic/angular';
//import { Network } from '@ionic-native/network/ngx';
import { ConfigService } from '../config.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage {

  constructor(
    private storage: Storage, 
    private navController: NavController,
    //private network: Network,
    private configService: ConfigService
    ) {}

  /*

    This home component is the Root of the app and the first logic that is loaded.
    We will check if an address already exists, if so, navigate to the elections page
    If not, navigate to the introduction page.

  */



  /* @TODO: Upon re-opening of the app, add logic to check if election date is in the past
  If so, we'll want to remove this old data from the Phone's storage since that election info
  will no longer be accessible. 
  */

  async ngOnInit() {

    // Initiate Storage
    await this.storage.create();

    this.checkAddressAndLoadElections();
    
  }

  async checkAddressAndLoadElections() {
    

    let res = await this.configService.getConfiguration();
    let hideIntroSlides = res["hideIntroSlides"];
    let preventAddressSave = res["preventAddressSave"];
    
    if(preventAddressSave) {
      if(hideIntroSlides) {
        this.navController.navigateRoot(`/address`);
      } else {
        this.navController.navigateRoot(`/introduction`);
      }
    } else {
      let exists = await this.storage.get('addressExists');
 
      if(exists) {

        this.navController.navigateRoot(`/elections`);
        
      } else {
    
        if(hideIntroSlides) {
          this.navController.navigateRoot(`/address`);
        } else {
          this.navController.navigateRoot(`/introduction`);
        }
        
      }
    }

  }
}

